import React from 'react';

const useArticleListPageUiState = ({ loading, articlesCount, filters, isMobile }) => {
  const [showEmpty, setShowEmpty] = React.useState(false);

  React.useEffect(() => {
    if (!loading && articlesCount === 0) {
      const timer = setTimeout(() => {
        setShowEmpty(true);
      }, 500);
      return () => clearTimeout(timer);
    }

    setShowEmpty(false);
    return undefined;
  }, [loading, articlesCount]);

  const [selectedArticle, setSelectedArticle] = React.useState(null);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [variant, setVariant] = React.useState(() => localStorage.getItem('article_variant') || 'detailed');

  React.useEffect(() => {
    if (isMobile && (variant === 'list' || variant === 'measurement')) {
      setVariant('detailed');
    }
  }, [isMobile, variant]);

  const [searchQuery, setSearchQuery] = React.useState(filters.search || '');
  const searchDebounceRef = React.useRef(null);
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' });
  const [selectedSources, setSelectedSources] = React.useState([]);
  const [selectedSentiments, setSelectedSentiments] = React.useState([]);
  const [selectedExposures, setSelectedExposures] = React.useState([]);
  const [selectedTags, setSelectedTags] = React.useState([]);
  const [selectedCollections, setSelectedCollections] = React.useState([]);
  const [selectedMediaTypes, setSelectedMediaTypes] = React.useState([]);
  const [quickNewsletterOpen, setQuickNewsletterOpen] = React.useState(false);
  const [quickNewsletterArticles, setQuickNewsletterArticles] = React.useState([]);
  const [selectedContentTypes, setSelectedContentTypes] = React.useState([]);
  const [selectedTiers, setSelectedTiers] = React.useState([]);
  const [selectedStatuses, setSelectedStatuses] = React.useState([]);
  const [selectedEntityType, setSelectedEntityType] = React.useState('');
  const [showFavoritesOnly, setShowFavoritesOnly] = React.useState(false);
  const [filtersOpen, setFiltersOpen] = React.useState(false);
  const [activeFiltersExpanded, setActiveFiltersExpanded] = React.useState(false);
  const [editModalOpen, setEditModalOpen] = React.useState(false);
  const [tagDialogOpen, setTagDialogOpen] = React.useState(false);
  const [articleForTags, setArticleForTags] = React.useState(null);
  const [confirmDialog, setConfirmDialog] = React.useState({
    open: false,
    message: '',
    onConfirm: null
  });
  const [smartScraperLoading, setSmartScraperLoading] = React.useState(false);
  const [aiBulkLoading, setAiBulkLoading] = React.useState(false);
  const [bulkTagDialogOpen, setBulkTagDialogOpen] = React.useState(false);
  const [bulkEditDialogOpen, setBulkEditDialogOpen] = React.useState(false);
  const [sentimentDialogOpen, setSentimentDialogOpen] = React.useState(false);
  const [bulkSentiment, setBulkSentiment] = React.useState('neutral');
  const [scrapingModalOpen, setScrapingModalOpen] = React.useState(false);
  const [collectionDialogOpen, setCollectionDialogOpen] = React.useState(false);
  const [articlesToAddToCollection, setArticlesToAddToCollection] = React.useState([]);
  const [removeTagsDialogOpen, setRemoveTagsDialogOpen] = React.useState(false);
  const [removeFromCollectionsDialogOpen, setRemoveFromCollectionsDialogOpen] = React.useState(false);
  const [tagPropagationDialogOpen, setTagPropagationDialogOpen] = React.useState(false);
  const [tagPropagationLoading, setTagPropagationLoading] = React.useState(false);
  const [pendingTagsToPropagate, setPendingTagsToPropagate] = React.useState([]);
  const [pendingArticleIdForTags, setPendingArticleIdForTags] = React.useState(null);
  const [similarArticlesForTags, setSimilarArticlesForTags] = React.useState([]);

  return {
    showEmpty,
    selectedArticle,
    setSelectedArticle,
    modalOpen,
    setModalOpen,
    variant,
    setVariant,
    searchQuery,
    setSearchQuery,
    searchDebounceRef,
    snackbar,
    setSnackbar,
    selectedSources,
    setSelectedSources,
    selectedSentiments,
    setSelectedSentiments,
    selectedExposures,
    setSelectedExposures,
    selectedTags,
    setSelectedTags,
    selectedCollections,
    setSelectedCollections,
    selectedMediaTypes,
    setSelectedMediaTypes,
    quickNewsletterOpen,
    setQuickNewsletterOpen,
    quickNewsletterArticles,
    setQuickNewsletterArticles,
    selectedContentTypes,
    setSelectedContentTypes,
    selectedTiers,
    setSelectedTiers,
    selectedStatuses,
    setSelectedStatuses,
    selectedEntityType,
    setSelectedEntityType,
    showFavoritesOnly,
    setShowFavoritesOnly,
    filtersOpen,
    setFiltersOpen,
    activeFiltersExpanded,
    setActiveFiltersExpanded,
    editModalOpen,
    setEditModalOpen,
    tagDialogOpen,
    setTagDialogOpen,
    articleForTags,
    setArticleForTags,
    confirmDialog,
    setConfirmDialog,
    smartScraperLoading,
    setSmartScraperLoading,
    aiBulkLoading,
    setAiBulkLoading,
    bulkTagDialogOpen,
    setBulkTagDialogOpen,
    bulkEditDialogOpen,
    setBulkEditDialogOpen,
    sentimentDialogOpen,
    setSentimentDialogOpen,
    bulkSentiment,
    setBulkSentiment,
    scrapingModalOpen,
    setScrapingModalOpen,
    collectionDialogOpen,
    setCollectionDialogOpen,
    articlesToAddToCollection,
    setArticlesToAddToCollection,
    removeTagsDialogOpen,
    setRemoveTagsDialogOpen,
    removeFromCollectionsDialogOpen,
    setRemoveFromCollectionsDialogOpen,
    tagPropagationDialogOpen,
    setTagPropagationDialogOpen,
    tagPropagationLoading,
    setTagPropagationLoading,
    pendingTagsToPropagate,
    setPendingTagsToPropagate,
    pendingArticleIdForTags,
    setPendingArticleIdForTags,
    similarArticlesForTags,
    setSimilarArticlesForTags
  };
};

export default useArticleListPageUiState;
